module.exports = __webpack_public_path__ + "static/media/Whistle_Icons_Dec2019_Oops.32b07f56.png";